export default __webpack_public_path__ + "static/media/bellIcon.4c5a0324.svg";